import * as React from 'react';

import { cn } from '@/lib/utils';

/*
 * Restyled to ScreenAtlas tokens: the `skeleton`/`skeleton-shimmer` tokens
 * (see tokens.css), swept by the `animate-shimmer` keyframe (index.css).
 * Shape the skeleton like the final content (aspect-ratio boxes for poster
 * grids, rows for feeds) so nothing jumps on load — ui-ux.md §7.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-shimmer rounded bg-skeleton', className)} {...props} />;
}

export { Skeleton };
